<template>
    <div class="goods-add">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
            <el-tab-pane label="规格库存" name="spec"></el-tab-pane>
            <el-tab-pane label="商品详情" name="content"></el-tab-pane>
            <el-tab-pane label="高级设置" name="buyset"></el-tab-pane>
        </el-tabs>
        <!--form表单-->
        <el-form ref="form" size="small" :model="form" label-width="180px">
            <!--基础信息-->
            <Basic v-show="activeName == 'basic'"></Basic>
            <!--规格设置-->
            <Spec v-show="activeName == 'spec'"></Spec>
            <!--商品详情-->
            <Content v-show="activeName == 'content'"></Content>
            <!--高级设置-->
            <Buyset v-show="activeName == 'buyset'"></Buyset>
            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">保存</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
    import GoodsApi from "@/api/goods.js";
    import Basic from "./part/Basic.vue";
    import Spec from "./part/Spec.vue";
    import Content from "./part/Content.vue";
    import Buyset from "./part/Buyset.vue";
    export default {
        components: {
            /*基础信息*/
            Basic,
            /*规格信息*/
            Spec,
            /*商品详情*/
            Content,
            /*高级设置*/
            Buyset
        },
        provide: function() {
            return {
                form: this.form
            };
        },
        data() {
            return {
                activeName: "basic",
                /*是否正在加载*/
                loading: false,
                /*form表单数据*/
                form: {
                    model: {
                        scene: "add",
                        /*商品名称*/
                        goods_name: "",
                        /*商品简称*/
                        goods_single_name:"",
                        /*商品编码*/
                        goods_no: "",
                        /*商品分类*/
                        category_id: null,
                        /*商品图片*/
                        image: [],
                        is_picture: 0,
                        contentImage: [],
                        video_id: 0,
                        poster_id: 0,
                        /*商品卖点*/
                        selling_point: "",
                        /*规格类别,默认10单规格，20多规格*/
                        spec_type: 10,
                        /*库存计算方式,默认20付款减库存，10下单减库存*/
                        deduct_stock_type: 20,
                        /*检查用户等级*/
                        is_alone_grade: 0,
                        /*单规格*/
                        sku: {
                            /*产品价格*/
                            goods_price: 0,
                            /*产品划线价*/
                            line_price: 0,
                            /*库存数量*/
                            stock_num: 0,
                            /*商品重量*/
                            goods_weight: 0,
                            /*商品编码*/
                            goods_no: "",
                            goods_sku_id: "",
                            /*村赞币*/
                            cunzan_coin: 0,
                            /*结算价*/
                            settlement_price: 0,
                            /*小包装数*/
                            package_num: 0,
                            /*地址价格*/
                            address_price: 0,
                        },
                        /*多规格类别*/
                        spec_many: {
                            /*多规格类别*/
                            spec_attr: [],
                            /*多规格表格数据*/
                            spec_list: []
                        },
                        /*商品详情内容*/
                        content: "",
                        /*运费模板ID*/
                        is_delivery_free: 0,
                        delivery_id: "",
                        /*商品状态*/
                        goods_status: 10,
                        audit_status: 0,
                        audit_remark: "",
                        /*初始销量*/
                        sales_initial: 0,
                        /*商品排序，默认100*/
                        goods_sort: 100,
                        /*是否开启积分赠送,默认1为开启，0为关闭*/
                        is_points_gift: 0,
                        /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
                        is_points_discount: 0,
                        /*最大积分抵扣数量*/
                        max_points_discount: 0,
                        /*商品分销是否开启*/
                        is_agent: 0,
                        /*是否开启单独分销,默认0为关闭，1为开启*/
                        is_ind_agent: 0,
                        /*分销佣金类型,默认10为百分比，20为固定金额*/
                        agent_money_type: 10,
                        /*一级佣金*/
                        first_money: 0,
                        /*二级佣金*/
                        second_money: 0,
                        /*三级佣金*/
                        third_money: 0,
                        /*是否虚拟商品*/
                        is_virtual: 0,
                        /*限购数量*/
                        limit_num: 0,
                        /*用户单次必须购买数量*/
                        minbuy: 0,
                        /*虚拟商品发货方式*/
                        virtual_auto: 0,
                        /*虚拟商品发货内容*/
                        virtual_content: "",
                        /*商品预告*/
                        is_preview: 0,
                        /*商品预告时间*/
                        preview_time: "",
                        /*新品*/
                        is_new: 0,
                        /*热销*/
                        is_hot: 0,
                        /*推荐*/
                        is_recommend: 0,
                        /*货源网址*/
                        source_url: "",
                        /*结算价*/
                        settlement_price: 0,
                        /*村赞币*/
                        cunzan_coin: 0,
                        ext:{
                            attr: [],
                        },
                        supplier_id:"",
                        goods_type_1688: '',
                        goods_sku_name_1688: '',
                    },
                    /*商品分类*/
                    category: [],
                    /*运费模板*/
                    delivery: [],
                    /*会员等级*/
                    gradeList: [],
                    supplierlist: [],
                    /*规格数据*/
                    specData: null,
                    /*是否锁住*/
                    isSpecLocked: false,
                    /*分销基础设置*/
                    basicSetting: {},
                    /*分销佣金设置*/
                    agentSetting: {},
                    audit_setting: {}
                },
            };
        },
        mounted() {
            /*获取基础数据*/
            this.getBaseData();
        },
        methods: {
            /*获取基础数据*/
            getBaseData: function() {
                let self = this;
                GoodsApi.getBaseData({}, true)
                    .then((res) => {
                        self.loading = false;
                        Object.assign(self.form, res.data);
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*转JSON字符串*/
            convertJson(list) {
                let obj = {};
                list.forEach((item) => {
                    obj[item.grade_id] = item.goods_equity;
                });
                return JSON.stringify(obj);
            },

            /*提交*/
            onSubmit: function() {
                let self = this;
                let params = self.form.model;
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        if (params.is_delivery_free == 0) {
                            params.delivery_id = 0;
                        } else {
                            if (params.delivery_id == "") {
                                self.$message({
                                    message: "请选择运费模板",
                                    type: "error"
                                });
                                return;
                            }
                        }
                        self.loading = true;
                        GoodsApi.addGoods(
                            {
                                params: JSON.stringify(params)
                            },
                            true
                        )
                            .then((data) => {
                                self.loading = false;
                                self.$message({
                                    message: "添加成功",
                                    type: "success"
                                });
                                self.$router.push("/goods/goods/index");
                            })
                            .catch((error) => {
                                self.loading = false;
                            });
                    } else {
                        self.$message({
                            message: "请检查必填项是否填写完整",
                            type: "error"
                        });
                    }
                });
            },

            /*取消*/
            cancelFunc() {
                this.$router.back(-1);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .basic-setting-content {
    }

    .goods-add {
        padding-bottom: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/views/goods/goods/add.vue